export const getNumberFieldValue = (value: unknown): number | null => {
	if (Array.isArray(value) && value.length >= 1) return Number(value[0]);
	if (typeof value === 'number' || typeof value === 'string') return Number(value);
	return null;
};
